
import { WorkHistoryForm } from "../../Forms/WorkHistoryForm";

const WorkInfoModal = ({data, refresh}) => {

  return (
    <div
        id="experience_info"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Work Experience</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">

              <WorkHistoryForm empId={data?.id} profile={data} onNext={refresh} isEditing={true} />
            </div>
          </div>
        </div>
      </div>
  )
}
export default WorkInfoModal;
